import React, { memo, useState, useCallback, useEffect } from 'react';

import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

function MeterTable({ composition, meters, onCallback, initials }) {
  const [data, setData] = useState([]);
  const [sendErrors, setSendErrors] = useState(false);

  // Change value of select field
  const handleChangeSelectField = useCallback(
    (value) => {
      const items = [...data];
      const index = items.findIndex(
        (item) => item.component === value.component
      );

      if (index >= 0) items[index] = value;
      else items.push(value);

      setData(items);
      onCallback(items);
    },
    [data]
  );

  // Fetch value of select in data array
  const handleGetValueSelectField = useCallback(
    (id) => {
      if (isEmpty(data)) return null;

      const item = data.find((d) => d.component === id);

      return item ? item.value : null;
    },
    [data]
  );

  useEffect(() => {
    if (!isEmpty(initials)) setData(initials);
  }, [initials]);

  useEffect(() => {
    if (!isEmpty(initials)) {
      const error = composition.find(
        (comp) => handleGetValueSelectField(comp.idproduto) === null
      );

      if (!isEmpty(error) && !sendErrors) {
        onCallback([]);
        setSendErrors(true);
      }
    }
  }, [initials, composition, sendErrors]);

  return (
    <S.Wrapper>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t('s.menu.configuracao.produto')}</TableCell>
              <TableCell align="right">
                {t('s.menu.configuracao.medidor')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {composition.map((comp) => (
              <TableRow key={Math.random().toString()}>
                <TableCell component="th" scope="row">
                  {comp.nomeabreviadoproduto}
                </TableCell>
                <TableCell align="right">
                  <select
                    disabled={!isEmpty(initials)}
                    onChange={({ target }) =>
                      handleChangeSelectField({
                        value: target.value,
                        component: comp.idproduto,
                      })
                    }
                    value={handleGetValueSelectField(comp.idproduto)}
                  >
                    <option selected disabled>
                      {t('s.geral.selecionar')}
                    </option>

                    {meters
                      .filter((meter) => meter.idproduto === comp.idproduto)
                      .map((meter) => (
                        <option
                          value={meter.medidorpresetproduto.toString()}
                          key={Math.random().toString()}
                        >
                          {meter.medidorpresetproduto}
                        </option>
                      ))}
                  </select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.Wrapper>
  );
}

MeterTable.propTypes = {
  composition: PropTypes.arrayOf(PropTypes.any).isRequired,
  meters: PropTypes.arrayOf(PropTypes.any).isRequired,
  initials: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  onCallback: PropTypes.func.isRequired,
};

MeterTable.defaultProps = {
  initials: [],
};

export default memo(MeterTable);
